import React from 'react';
import clsx from 'clsx';
import { TooltipReact } from 'common/components/tooltip';
import { DropMenuReact } from 'common/components/drop-menu';
import { Directions } from 'common/components/drop-menu/types';
import { useTranslation } from 'common/i18n/hooks';
import styles from './index.module.styl';
export type EventIndicatorProps = {
  played?: boolean;
  isObserved?: boolean;
  tooltipText: string;
  isHovered?: boolean;
  groupCount?: number;
};
export function EventIndicator(props: EventIndicatorProps) {
  const {
    t
  } = useTranslation();
  return <div className={clsx(styles.eventIndicator, {
    [styles.played]: props.played,
    [styles.observed]: props.isObserved,
    [styles.isHovered]: props.isHovered
  })} data-sentry-component="EventIndicator" data-sentry-source-file="index.tsx">
      {props.isHovered === undefined ? <TooltipReact>{props.tooltipText}</TooltipReact> : <DropMenuReact open={props.isHovered} offset={0} direction={Directions.UpCenter}>
          <div className={styles.interactionContext}>
            <div>
              {props.groupCount && props.groupCount > 1 ? t("session-replay.event-group-label", {
            name: props.tooltipText,
            count: props.groupCount - 1
          }) : props.tooltipText}
            </div>
          </div>
        </DropMenuReact>}
    </div>;
}